import { SetItemsAction, TypeKeys } from '@common/react/store/ItemsProviderStore';
import { SortingDirection } from '@common/react/components/Core/ItemsProvider/ItemsProvider';
import { TypeKeys as ItemProviderTypeKeys } from '@common/react/store/ItemProviderStore';

import { CompanyFeature } from '@commonTuna/react/objects/CompanyFeature';
import { AppointmentStatus } from '@commonTuna/react/objects/AppointmentStatus';
import { AppointmentType } from '@commonTuna/react/objects/AppointmentType';

import { Init } from '@app/objects/Init';
import { HiddenAppointmentDots } from '@app/objects/HiddenAppointmentDots';
import { Location } from '@app/objects/Location';
import { UserFavorite } from '@app/objects/User';
import { defaultOptions as LocationDefaultOptions } from '@app/components/UI/Location/defaultOptions';
import { defaultOptions as StatusDefaultOptions } from '@app/components/UI/AppointmentStatus/defaultOptions';
import { defaultOptions as AppointmentTypeDefaultOptions } from '@app/components/UI/AppointmentType/defaultOptions';

export const customReduxActions = (dispatch, init: Init) => {
	const buildDataAction = {
		type: ItemProviderTypeKeys.SETITEM,
		storageName: 'buildData',
		params: {},
		objectType: 'buildData',
		item: {
			buildNumber: init.buildNumber,
			buildDate: init.buildDate,
			debug: init.debug,
			maxNumberLimit: init.maxNumberLimit,
			maxDescriptionLength: init.maxDescriptionLength,
			maxTextLength: init.maxTextLength,
			maxEmailSubjectLength: init.maxEmailSubjectLength,
			maxNameLength: init.maxNameLength,
			maxAddressLength: init.maxAddressLength,
			helpBotUserId: init.helpBotUserId,
		},
	};

	dispatch(buildDataAction);

	if (init.hostOptions) {
		const hostOptionsAction = {
			type: ItemProviderTypeKeys.SETITEM,
			storageName: 'hostOptions',
			item: init.hostOptions,
			params: {},
			objectType: 'hostOptions',
		};

		dispatch(hostOptionsAction);
	}

	/* if (init.facebookOptions) {
		const facebookOptionsAction = {
			type: ItemProviderTypeKeys.SETITEM,
			storageName: 'facebookOptions',
			item: init.facebookOptions,
			params: {},
			objectType: 'facebookOptions',
		};

		dispatch(facebookOptionsAction);
	} */

	if (init.instagramLoginOptions) {
		const instagramLoginOptionsAction = {
			type: ItemProviderTypeKeys.SETITEM,
			storageName: 'instagramLoginOptions',
			item: init.instagramLoginOptions,
			params: {},
			objectType: 'instagramLoginOptions',
		};

		dispatch(instagramLoginOptionsAction);
	}

	if (init.companyFeatures) {
		const companyFeaturesAction: SetItemsAction<CompanyFeature> = {
			type: TypeKeys.SETITEMS,
			storageName: 'companyFeatures',
			items: init.companyFeatures,
			total: init.companyFeatures.length,
			objectType: 'companyFeature',
			params: {
				count: 100,
			},
		};

		dispatch(companyFeaturesAction);
	}

	if (init.companySettings) {
		const companySettingsAction = {
			type: ItemProviderTypeKeys.SETITEM,
			storageName: 'companySettings',
			item: init.companySettings,
			params: {},
			objectType: 'companySettings',
		};

		dispatch(companySettingsAction);
	}

	if (init.userFavorites) {
		const userFavoritesAction: SetItemsAction<UserFavorite> = {
			type: TypeKeys.SETITEMS,
			storageName: 'userFavorites',
			objectType: 'userFavorite',
			items: init.userFavorites,
			params: {
				count: 100,
				current: 1,
			},
		};

		dispatch(userFavoritesAction);
	}

	if (init.routesPropsPagesMap) {
		const routesPropsPagesMapAction = {
			type: ItemProviderTypeKeys.SETITEM,
			storageName: 'routesPropsPagesMap',
			item: init.routesPropsPagesMap,
			params: {},
			objectType: 'routesPropsPagesMap',
		};

		dispatch(routesPropsPagesMapAction);
	}

	if (init.enumAccesses) {
		const enumAccessesAction = {
			type: ItemProviderTypeKeys.SETITEM,
			storageName: 'enumAccesses',
			item: init.enumAccesses,
			params: {},
			objectType: 'enumAccesses',
		};

		dispatch(enumAccessesAction);
	}

	if (init.hiddenAppointmentDots) {
		const hiddenAppointmentDotsAction: SetItemsAction<HiddenAppointmentDots> = {
			type: TypeKeys.SETITEMS,
			storageName: 'hiddenAppointmentDots',
			objectType: 'hiddenAppointmentDots',
			items: init.hiddenAppointmentDots,
			params: {},
		};

		dispatch(hiddenAppointmentDotsAction);
	}

	if (init.userLocations) {
		const userLocationsAction: SetItemsAction<Location> = {
			type: TypeKeys.SETITEMS,
			storageName: 'locations',
			objectType: 'locations',
			items: init.userLocations,
			params: {
				...LocationDefaultOptions.filters,
				...LocationDefaultOptions.pagination,
				pageSize: undefined,
			},
		};

		dispatch(userLocationsAction);
	}

	if (init.appointmentStatuses) {
		const appointmentStatusesAction: SetItemsAction<AppointmentStatus> = {
			type: TypeKeys.SETITEMS,
			storageName: 'appointmentStatuses',
			objectType: 'appointmentStatuses',
			items: init.appointmentStatuses,
			params: {
				...StatusDefaultOptions.filters,
				...StatusDefaultOptions.pagination,
				pageSize: undefined,
			},
		};

		dispatch(appointmentStatusesAction);
	}

	if (init.appointmentTypes) {
		const appointmentTypesAction: SetItemsAction<AppointmentType> = {
			type: TypeKeys.SETITEMS,
			storageName: 'appointmentTypes',
			objectType: 'appointmentTypes',
			items: init.appointmentTypes,
			params: {
				...AppointmentTypeDefaultOptions.filters,
				...AppointmentTypeDefaultOptions.pagination,
				pageSize: undefined,
			},
		};

		dispatch(appointmentTypesAction);
	}
};
